// Shared validation for SHSAT Math fill-in-the-blank answers, used by both the
// legacy (Module) and adaptive (AdaptiveModule) renderers so the rules stay
// identical. Math-section blanks accept only a number: digits, at most one
// decimal point, an optional single minus sign at the far left, and at most 7
// characters total (the minus sign and decimal point count toward the 7).
// Returns null if the value is acceptable, else the popup message to show.
export function validateMathEntry(value: string): string | null {
    if (/[^0-9.\-]/.test(value)) {
        return 'Only numbers, a decimal point, and a leading minus sign are allowed.';
    }
    const minusCount = (value.match(/-/g) || []).length;
    if (minusCount > 1 || (minusCount === 1 && value.indexOf('-') !== 0)) {
        return 'A minus sign is only allowed at the very start of the answer.';
    }
    if ((value.match(/\./g) || []).length > 1) {
        return 'Only one decimal point is allowed.';
    }
    if (value.length > 7) {
        return 'You can enter at most 7 characters (including the minus sign and decimal point).';
    }
    return null;
}
